module.exports = __webpack_public_path__ + "media/images/lig/uxu-customer-2-f475db66e206f5468f357952dd38679a.jpg";